import styled from 'styled-components';

type Props = {
  padding?: boolean;
};

export const Container = styled.div<Props>`
  text-align: center;
  padding: ${({ padding }) => (padding ? '64px 0' : '0')};
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.grey4};
  font-weight: bold;
  text-transform: uppercase;
  margin: 8px;
`;
